module.exports = __webpack_public_path__ + "img/1.cb12d70f.png";